<footer class="footer">
    <div class="container">
        <div class="content has-text-centered">
            <p>
                <i><a target="_blank" href="http://learningml.org">LearningML</a></i> Copyright © 2022 <a class="footer-link" target="_blank" href="http://juandarodriguez.es">Juan David Rodríguez García</a> 
            </p>
        </div>
    </div>
</footer>